import {SET_AUTH_TAB_NUMBER} from "../actions/AuthTabActions";

const initialState = {
    authTab: 0,
};

export default function AuthTabReducer(state = initialState, action) {
    switch (action.type) {
        case SET_AUTH_TAB_NUMBER:
            return {
                ...state,
                authTab: action.payload,
            }
    }

    return state;
}